import React from "react";
import { Stack } from "@mui/system";
import { Box, Switch } from "@mui/material";
import { Typography, TextField, Grid } from "@mui/material";
import deleteIcon from "../../Images/delete_red_icon.svg";
import infoIcon from "../../Images/blue_info.svg";
import "./Student.scss";
import { useDispatch, useSelector } from "react-redux";
import { studentID, showStudentDetails } from "../../redux/features/student";
import Cookies from "universal-cookie";
import { ROLE, APP_ROUTES, FOMRS } from "../../globals/constants";
import { useNavigate } from "react-router-dom";

const StudentCard = (props) => {
  const { res, lgWidth, ondeleteClick } = props;
  const dispatch = useDispatch();
  const cookies = new Cookies();
  const loginData = cookies.get("loginData");
  let userID = loginData?.id;
  let userRole = loginData?.role_code;

  const editStudent = (e) => {
    e.stopPropagation();
  };
  const navigate = useNavigate();

  const deleteStudent = (e, id) => {
    e.stopPropagation();
    ondeleteClick(id);
  };

  return (
    <>
      {res?.length > 0 ? (
        res?.map((res) => {
          let title = res?.name;
          let titlelength = title?.length;
          let slicedTitle = title?.slice(0, 25);

          let trainingCenter = res?.[`studio.studio_name`];
          let trainingCenterLength = trainingCenter?.length;
          let slicedtrainingCenter = trainingCenter?.slice(0, 12);
          return (
            <Grid
              container
              direction="row"
              xs={12}
              sm={6}
              md={lgWidth}
              lg={lgWidth}
              xlg={lgWidth}
            >
              <Box
                sx={{
                  width: "95%",
                  m: 1,
                  backgroundColor: "var(--mainBoxBG)",
                  borderRadius: 1.5,
                }}
                className="cardViewTc"
                id="student_CardView"
                // onClick={() => {
                // setTainID(res.id);
                // console.log('name', res.id);
                // setShowDetails(true);
                // 	dispatch(studentID(res?.id));
                // 	dispatch(showStudentDetails(true));
                // }}
              >
                <Stack direction="row" justifyContent="space-between">
                  <Stack className="cd-fs-1" sx={{ mt: "4%", ml: "3%" }}>
                    Student Name -{" "}
                    {titlelength > 25 ? `${slicedTitle}...` : res?.name}
                  </Stack>
                </Stack>
                <Stack
                  sx={{ mt: "5%", mb: "3%", ml: "3%" }}
                  direction="row"
                  spacing="1%"
                >
                  <span className="cd-fs cardText">{res?.created_at}</span>
                  <Stack
                    sx={{ borderRight: "1px solid #338fee", height: "15px" }}
                  ></Stack>
                  <span className="cd-fs cardText margenSetTop">
                    Training Center -
                    <span className="fs-3">
                      {trainingCenterLength > 18
                        ? `${slicedtrainingCenter}...`
                        : res?.[`studio.studio_name`]}
                    </span>
                  </span>
                  {/* <Stack
										sx={{ borderRight: '1px solid #338fee', height: '15px' }}
									></Stack>
									<span className="cd-fs cardText">
										Instructor -{res?.[`studio.admin_name`]}
									</span> */}
                </Stack>
                <Stack direction="row" margin="1%">
                  <Grid item xs={userRole === ROLE.ADMIN ? 12 : 10}>
                    <Box
                      sx={{
                        width: "95%",
                        background: "var(--subBoxBG)",
                        m: 1,
                        mt: 1,
                        borderRadius: 1.5,
                      }}
                    >
                      <Stack
                        className="cardFontH2"
                        justifyContent="space-between"
                        direction="row"
                      >
                        <Stack className="cd-fs" marginTop="1%">
                          Average Session Length :
                        </Stack>
                        <Stack className="cd-fs-1">
                          {res?.avg_session_length}hrs
                        </Stack>
                      </Stack>
                    </Box>
                    <Box
                      sx={{
                        width: "95%",
                        background: "var(--subBoxBG)",
                        m: 1,
                        borderRadius: 1.5,
                      }}
                    >
                      <Stack
                        className="cardFontH2"
                        justifyContent="space-between"
                        direction="row"
                      >
                        <Stack className="cd-fs" marginTop="1%">
                          No. of disconnect :
                        </Stack>
                        <Stack className="cd-fs-1">
                          {res?.training_disconnect}
                        </Stack>
                      </Stack>
                    </Box>
                    <Box
                      sx={{
                        width: "95%",
                        background: "var(--subBoxBG)",
                        m: 1,
                        // ml: '2%',
                        borderRadius: 1.5,
                      }}
                    >
                      <Stack
                        className="cardFontH2"
                        justifyContent="space-between"
                        direction="row"
                      >
                        <Stack className="cd-fs" marginTop="1%">
                          No. of session attended :
                        </Stack>
                        <Stack className="cd-fs-1">{res?.training_count}</Stack>
                      </Stack>
                    </Box>
                  </Grid>
                  {userRole === ROLE.ADMIN ? (
                    ""
                  ) : (
                    <Grid item xs={2}>
                      <Box
                        sx={{
                          width: "80%",
                          background: "var(--subBoxBG)",
                          m: 0.5,
                          mt: 1,
                          borderRadius: 1.5,
                          height: "86%",
                        }}
                      >
                        <Stack direction="column">
                          <Stack
                            direction="row"
                            sx={{ justifyContent: "center", p: "5%" }}
                          >
                            <Stack paddingTop="5%">
                              <span className="cd-fs actionFont">Action</span>
                            </Stack>
                          </Stack>
                          <Stack
                            spacing={2}
                            sx={{
                              justifyContent: "center",
                              p: { xs: "7%", sm: "30%" },
                              paddingLeft: { xs: "30%" },
                              cursor: "pointer",
                            }}
                          >
                            <Stack sx={{ width: 16, height: 16, p: "2%" }}>
                              <img
                                src={infoIcon}
                                alt=""
                                onClick={(e) => {
                                  editStudent(e);
                                  navigate(APP_ROUTES.ADD_STUDENT, {
                                    state: {
                                      type: FOMRS.VIEW,
                                      id: res.id,
                                    },
                                  });
                                }}
                              />
                            </Stack>
                            <Stack
                              sx={{
                                width: 16,
                                height: 16,
                                p: "2%",
                                cursor: "pointer",
                              }}
                              marginTop="2%"
                            >
                              <img
                                src={deleteIcon}
                                alt=""
                                onClick={(e) => {
                                  deleteStudent(e, res.id);
                                }}
                              />
                            </Stack>
                          </Stack>
                        </Stack>
                      </Box>
                    </Grid>
                  )}
                </Stack>
              </Box>
            </Grid>
          );
        })
      ) : (
        <Stack className="NO_RECORD_FOUND">No Record Found</Stack>
      )}
    </>
  );
};

export default StudentCard;
